import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Loading from './loading';

const ProtectedLayout = ({ isAuthenticated, loading, user }) => {
  if (loading) {
    return <Loading />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/VoyagerIndexLookup/login" replace />;
  }

  // Passes the user and onLogout function to the child route components via context
  return <Outlet context={{ user }} />;
};

export default ProtectedLayout;